<!-- eslint-disable vue/valid-v-for -->
<template>
  <div class="page">
    <progress-system :isLoad="system.isLoad"></progress-system>
    <v-container text-xs-center fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex v-if="aluno != null">
          <v-avatar size="200">
            <v-img v-if="aluno.Foto == null" src="https://www.reabilitybauru.com.br/wp-content/uploads/2017/01/perfil-300x300.png"></v-img>
            <v-img v-else :src="'http://sis.al.rn.dti.systems/sis/cliente/fotos/' + aluno.Matricula + '.jpg'"></v-img>
          </v-avatar>
          <div>
            <br><br>
            <h1>{{aluno.Nome}}</h1>
            <br>
            <h2>Matrícula: {{aluno.Matricula}}</h2>
            <h2>CPF: {{aluno.CPF}}</h2>
            <h2>Data de Nascimento: {{$moment(aluno.Nascimento).format('L')}}</h2>
            <div v-if="turmas.length != 0">
              <h2>Turmas ativas:</h2>
              <v-list>
                <template v-for="turma in this.turmas"> 
                  <v-list-tile-content >
                    <div style="display: flex; align-items: center;">
                      <span>Turma:</span>
                      <span style="margin-left: 8px; font-weight: bold;">{{ turma.Descricao }}</span>
                    </div>
                    <div style="display: flex; align-items: center;">
                      <span>Dias:</span>
                      <span style="margin-left: 8px; font-weight: bold;">{{ formatarDiasSemana(turma.dias) }} </span>
                    </div>
                    <div style="display: flex; align-items: center;">
                      <span>Horário:</span>
                      <span style="margin-left: 8px; font-weight: bold;">{{ turma.HoraInicial }} as {{ turma.HoraFinal }}</span>
                    </div>
                  </v-list-tile-content>
                  <v-divider></v-divider>
                </template>
              </v-list>
              <div v-if="temAulaHoje()==true">
                <h3 style="color: green;">Tem aula hoje</h3>
              </div>
              <div v-else>
                <h3 style="color: red;">Nenhuma aula hoje</h3>
              </div>
            </div>
            <div v-else>
              <h3 style="color: red;">Nenhuma turma ativa!</h3>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import ProgressSystem from '../components/ProgressSystem'
  export default{
    components:{
      ProgressSystem
    },
    data () {
      return{
        system: {
          isLoad: true
        },
        aluno: null,
        matricula: this.$route.params.pathMatch,
        hoje: new Date(),
        turmas: [],
      }
    },
    methods:{
      getAluno(){
        this.axios.get(`user/${this.matricula}`).then( res => {
          this.turmas = res.data.turmas
          this.aluno  = res.data.aluno

          this.system.isLoad = false
        }).catch(e => {
          this.aluno = e.response.data
          this.system.isLoad = false
        })
      },
      formatarDiasSemana(dias){
        const diasArray = dias.split(',').map(Number);
        const diasDaSemana = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
        const diasFormatados = diasArray.map(dia => diasDaSemana[dia - 1]);
        return diasFormatados.join(', ');
      },
      temAulaHoje(){
        for(let i=0; i<this.turmas.length; i++)
          if(this.turmas[i].aulaHoje == true)
            return true;
        return false;
      }
    },
    mounted(){
      this.getAluno()
    }
  }
</script>
